/** Shared React Query keys for the Mission Control dashboard and its Search section. */

export const HOME_STOCK_QUERY_KEY = ['stocks'] as const;
export const HOME_NEWS_QUERY_KEY = ['home', 'news'] as const;
export const HOME_KNOWLEDGE_LINKS_QUERY_KEY = ['home', 'knowledge-links'] as const;
export const HOME_PEOPLE_QUERY_KEY = ['home', 'people'] as const;
export const PEOPLE_MAP_QUERY_KEY = ['people', 'map'] as const;
export const HOME_TOP_PRIORITIES_QUERY_KEY = ['home', 'top-priorities'] as const;

export const STOCK_STALE_TIME_MS = 2 * 60 * 1000;
export const NEWS_STALE_TIME_MS = 2 * 60 * 1000;
export const KNOWLEDGE_LINKS_STALE_TIME_MS = 3 * 60 * 60 * 1000;
export const PEOPLE_STALE_TIME_MS = 5 * 60 * 1000;
export const GRATITUDES_STALE_TIME_MS = 2 * 60 * 1000;
export const EMPLOYEE_MAP_STALE_TIME_MS = 15 * 60 * 1000;
export const JIRA_STALE_TIME_MS = 3 * 60 * 1000;
export const AGENDA_STALE_TIME_MS = 10 * 60 * 1000;
export const TOP_PRIORITIES_STALE_TIME_MS = 5 * 60 * 1000;
